import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { CmsService, ContentSlotData, Currency, CurrencyService, RoutingService, UrlPipe, TranslatePipe } from '@spartacus/core';
import * as _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { KnBrQuoteEntry } from '../../../../models/kn-br-quote.model';
import { KnBrDateHelper } from '../../../../shared/kn-br-date.helper';
import { KnBrQuoteEntryService } from '../../../../store/kn-br-quote-entry/kn-br-quote-entry.service';
import { KnBrQuotesService } from '../../../../store/kn-br-quotes/kn-br-quotes.service';
import { KnBrQuoteCommentsPopupComponent } from './../../kn-br-quote-comments-popup/kn-br-quote-comments-popup.component';
import { Actions, ofType } from '@ngrx/effects';
import { KnBrQuotesActionTypes } from 'src/app/store/kn-br-quotes/kn-br-quotes.action';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrCommonPopUpComponent } from 'src/app/kn-br-customer360/kn-br-common-pop-up/kn-br-common-pop-up.component';
import { NgClass, SlicePipe } from '@angular/common';
import { MediaComponent } from '@spartacus/storefront';
import { RouterLink } from '@angular/router';
import { KnBrNumbersOnlyDirective } from '../../../../shared/directive/kn-br-numbers-only.directive';
import { KnBrQuotePartialItemComponent } from './kn-br-quote-partial-item/kn-br-quote-partial-item.component';
//  Need To Discuss
@Component({
    selector: 'kn-br-quote-item',
    templateUrl: './kn-br-quote-item.component.html',
    styleUrls: ['./kn-br-quote-item.component.scss'],
    providers: [KnBrDateHelper],
    imports: [NgClass, MediaComponent, RouterLink, ReactiveFormsModule, KnBrNumbersOnlyDirective, KnBrQuotePartialItemComponent, SlicePipe, UrlPipe, TranslatePipe]
})
export class KnBrQuoteItemComponent implements OnInit, OnDestroy {
  @Input() entry: any;
  @Input() isPartial: any;
  @Input() knbrOrderType: any;
  @Input() status: any;
  reqShipDate = new FormControl();
  quantity = new FormControl();
  priceAdjusted = new FormControl();
  subscription = new Subscription();
  modalRef: any;
  components: ContentSlotData;
  knBrAbsoluteDiscount = new FormControl();
  knBrPercentileDiscount = new FormControl();
  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  selectedCustomer: CustomerData;
  quoteHeaderDiscountType$: Observable<boolean> = this.knBrQuoteService.loadDiscountType$();
  currencyData$: Observable<string> = this.currencyService.getActive();
  isAbsoluteDiscount = false;
  activeCurrency: string;
  selectedProductsCodes: string[];
  subscriptionSelectedProduct: Subscription;
  dateFormat$: Observable<any> = this.currentUserService.get().pipe(
    filter((user: any) => user && !!user.dateFormat),
    map((user: any) => user.dateFormat)
  );
  netPriceUnit: any;
  totalPrice: any;
  isZtdOrZqtd: boolean;
  salesText = [];
  materialText = [];
  disableNavigation = true;

  constructor(
    protected currentUserService: UserAccountFacade,
    protected modalService: NgbModal,
    protected knBrQuoteEntryService: KnBrQuoteEntryService,
    protected knBrQuoteService: KnBrQuotesService,
    protected cdr: ChangeDetectorRef,
    protected cmsService: CmsService,
    protected knBrDateHelper: KnBrDateHelper,
    protected currencyService: CurrencyService,
    protected knBrCommonService: KnBrCommonService,
    protected actions$: Actions,
    protected routingService: RoutingService,
    protected knBrCustomerContextService: KnBrCustomerContextService
  ) {
    this.subscription.add(
      this.currencyData$.subscribe((currency) => {
        this.currencyService.getAll().subscribe((currencies) => {
          if (currency && currencies?.length) {
            const activeCurrencyObj: Currency = _.find(currencies, ['isocode', currency]);
            this.activeCurrency = activeCurrencyObj ? activeCurrencyObj.symbol : null;
          }
        });
      })
    );
    this.subscription.add(
      this.knBrQuoteService.loadDiscountType$().subscribe((value) => {
        this.isAbsoluteDiscount = value;
      })
    );
    this.subscriptionSelectedProduct = this.knBrQuoteService
      .loadSelectedProducts$()
      .subscribe((selectedProductsCodes) => {
        this.selectedProductsCodes = selectedProductsCodes;
      });
    this.actions$.pipe(ofType(KnBrQuotesActionTypes.KnBrQuoteLoadAction)).subscribe({
      next: (res: any) => {
        if (res?.payload?.payload?.entry?.entryNumber === this.entry.entryNumber) {
          const entry = res?.payload?.payload?.entry;
          this.reqShipDate.setValue(this.knBrDateHelper.getDate(entry?.requestedShipDate));
          this.quantity.setValue(entry?.quantity?.toLocaleString());
          this.priceAdjusted.setValue(entry.knbrTotalPrice?.priceAdjusted?.value?.toFixed(2));
          this.knBrAbsoluteDiscount.setValue(entry.knbrTotalPrice?.knbrAbsoluteDiscount?.value?.toFixed(2));
          this.knBrPercentileDiscount.setValue(entry.knbrTotalPrice?.knbrPercentileDiscount);
          this.reqShipDate.enable();
          this.quantity.enable();
          this.priceAdjusted.enable();
          this.knBrPercentileDiscount.enable();
          this.knBrAbsoluteDiscount.enable();
        }
      },
    });
  }

  ngOnInit(): void {
    if (this.entry) {
      setTimeout(() => {
        this.reqShipDate.setValue(this.knBrDateHelper.getDate(this.entry.requestedShipDate));
      }, 2000);
      this.isZtdOrZqtd = this.knbrOrderType === 'ZTD' || this.knbrOrderType === 'ZQTD';
      this.netPriceUnit = this.isZtdOrZqtd ? '-' : (this.entry?.knbrTotalPrice?.formatedNetPrice + this.entry?.knbrTotalPrice?.conditionUnit);
      this.totalPrice = this.isZtdOrZqtd ? '-' : this.entry.totalPrice?.formattedValue;
      this.quantity.setValue(this.entry.quantity.toLocaleString());
      this.priceAdjusted.setValue(this.entry.knbrTotalPrice?.priceAdjusted?.value?.toFixed(2));
      this.knBrAbsoluteDiscount.setValue(this.entry.knbrTotalPrice?.knbrAbsoluteDiscount?.value?.toFixed(2));
      this.knBrPercentileDiscount.setValue(this.entry.knbrTotalPrice?.knbrPercentileDiscount);
      this.knBrPercentileDiscount.enable();
      this.knBrAbsoluteDiscount.enable();
      this.subscription = this.knBrQuoteEntryService.get$.subscribe((response: KnBrQuoteEntry) => {
        if (response && response.entryNumber === this.entry.entryNumber && response.product) {
          this.entry = response;
          this.reqShipDate.setValue(this.knBrDateHelper.getDate(this.entry.requestedShipDate));
          this.quantity.setValue(this.entry.quantity.toLocaleString());
          this.priceAdjusted.setValue(this.entry.knbrTotalPrice?.priceAdjusted?.value?.toFixed(2));
          this.knBrPercentileDiscount.setValue(this.entry.knbrTotalPrice?.knbrPercentileDiscount);
          this.knBrAbsoluteDiscount.setValue(this.entry.knbrTotalPrice?.knbrAbsoluteDiscount?.value);
          this.cdr.markForCheck();
          this.reqShipDate.enable();
          this.quantity.enable();
          this.priceAdjusted.enable();
          this.knBrPercentileDiscount.enable();
          this.knBrAbsoluteDiscount.enable();
        }
      });
    }

    this.subscription.add(
      this.customerContextData$.subscribe((value) => {
        if (value) {
          this.selectedCustomer = value;
        }
      })
    );
  }

  getProductRouteParams(product: any) {
    if (!product) {
      return product;
    }

    const productCode = product.baseProduct || product.code;
    return {
      ...product,
      code: productCode,
    };
  }

  getProductQueryParams(product: any) {
  return product?.code ? { genericVariantProduct: product.code } : null;
}

  update() {
    if (
      (this.reqShipDate.valid && this.reqShipDate.dirty) ||
      (this.quantity.valid && this.quantity?.dirty) ||
      (this.priceAdjusted.valid && this.priceAdjusted.dirty)
    ) {
      const entryObj: KnBrQuoteEntry = {
        quantity: this.knBrCommonService.getQuantityBasedOnMoq(
          Number(this.quantity.value) ? Number(this.quantity.value) : 0,
          this.entry.minimumOrderQuantity
        ),
        knbrTotalPrice: {
          priceAdjusted: {
            value: this.priceAdjusted.value,
          },
          knbrAbsoluteDiscount: {
            value: this.knBrAbsoluteDiscount.value,
          },
          knbrPercentileDiscount: this.knBrPercentileDiscount.value,
        },
        requestedShipDate: '',
        entryNumber: this.entry.entryNumber,
      };
      if (this.reqShipDate.value) {
        entryObj.requestedShipDate = this.knBrDateHelper.formatDate(this.reqShipDate.value);
      }
      this.knBrQuoteEntryService.update(entryObj);
      this.reqShipDate.disable();
      this.quantity.disable();
      this.priceAdjusted.disable();
      this.knBrAbsoluteDiscount.disable();
      this.knBrPercentileDiscount.disable();
    }
  }

  splitSalesText(str) {
    if (str !== undefined) {
      const replaceAmpersand = str?.replaceAll('<(>&<)>', '&');
      this.salesText = replaceAmpersand?.split('|');
    }
  }

  splitMaterialText(str) {
    if (str !== undefined) {
      const replaceAmpersand = str?.replaceAll('<(>&<)>', '&');
      this.materialText = replaceAmpersand?.split('|');
    }
  }

  openComment(entry?: KnBrQuoteEntry) {
    let modalInstance: any;
    this.modalRef = this.modalService.open(KnBrQuoteCommentsPopupComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.entryNumber = entry.entryNumber;
    modalInstance.editable = this.isDisabled();
  }

  isChecked(code: any): boolean {
    if (this.selectedProductsCodes) {
      return this.selectedProductsCodes.indexOf(code) > -1;
    }
    return false;
  }
  changeCheckBox(event) {
    event.stopPropagation();
    const selectedProductCodes = event.currentTarget.checked ? this.addProductCode() : this.removeProductCode();
    this.knBrQuoteService.setSelectedProducts(selectedProductCodes);
  }

  private addProductCode() {
    if (this.selectedProductsCodes && this.selectedProductsCodes.length) {
      this.selectedProductsCodes.push(this.entry.entryNumber as unknown as string);
    } else {
      this.selectedProductsCodes = [this.entry.entryNumber as unknown as string];
    }
    return this.selectedProductsCodes;
  }
  private removeProductCode() {
    this.selectedProductsCodes.splice(
      this.selectedProductsCodes.indexOf(this.entry.entryNumber as unknown as string),
      1
    );
    return this.selectedProductsCodes;
  }

  isDisabled() {
    this.cmsService
      .getContentSlot('KnBrQuoteHeaderSlot')
      .subscribe((value) => (this.components = value))
      .unsubscribe();
    if (
      (this.components &&
        this.components.components &&
        this.components.components.length &&
        this.components.components[0].flexType === 'KnBrQuoteHeaderComponentReadOnly') ||
      !this.isEditable()
    ) {
      this.reqShipDate.disable();
      this.quantity.disable();
      this.priceAdjusted.disable();
      this.knBrAbsoluteDiscount.disable();
      this.knBrPercentileDiscount.disable();
      return true;
    }
    return false;
  }

  isEditable() {
    let editable = true;
    this.knBrQuoteService.get$.subscribe((value) => (editable = value.editable)).unsubscribe();
    return editable;
  }

  priceadjust(event) {
    if (
      (this.reqShipDate.valid && this.reqShipDate.dirty) ||
      (this.knBrAbsoluteDiscount.valid && this.knBrAbsoluteDiscount?.dirty) ||
      (this.knBrPercentileDiscount.valid && this.knBrPercentileDiscount?.dirty)
    ) {
      const entryObj: KnBrQuoteEntry = {
        knbrTotalPrice: {
          knbrAbsoluteDiscount: {},
        },
        quantity: this.quantity.value,
        requestedShipDate: '',
        entryNumber: this.entry.entryNumber,
      };
      if (this.isAbsoluteDiscount) {
        entryObj.knbrTotalPrice.knbrAbsoluteDiscount.value = event.knBrAbsoluteDiscount;
      } else {
        entryObj.knbrTotalPrice.knbrPercentileDiscount = event.knBrPercentileDiscount;
      }
      if (this.reqShipDate.value) {
        entryObj.requestedShipDate = this.knBrDateHelper.formatDate(this.reqShipDate.value);
      }
      this.knBrQuoteEntryService.priceadjust(entryObj);
      this.reqShipDate.disable();
      this.quantity.disable();
      this.priceAdjusted.disable();
      this.knBrAbsoluteDiscount.disable();
      this.knBrPercentileDiscount.disable();
    }
  }

  updatePricePercentileDiscount() {
    const entryObj: any = {
      knBrPercentileDiscount: this.knBrPercentileDiscount.value ? this.knBrPercentileDiscount.value : '',
      entryNumber: this.entry.entryNumber,
    };
    this.priceadjust(entryObj);
  }

  updateAbsoluteDiscount() {
    const entryObj: any = {
      knBrAbsoluteDiscount: this.knBrAbsoluteDiscount.value ? this.knBrAbsoluteDiscount.value : '',
      entryNumber: this.entry.entryNumber,
    };
    this.priceadjust(entryObj);
  }

  navigateToOrderDetails(order) {
    // const customerContext: CustomerData = {
    //   customerNumber: this.selectedCustomer?.customerNumber,
    //   customerName: this.selectedCustomer?.customerName,
    // };
    // this.knBrCustomerContextService.set(customerContext);
    this.routingService.go({ cxRoute: 'orderDetails', params: { code: order } });
  };

  openPopup(data, materialNum) {
    let modalInstance: any;
    this.modalRef = this.modalService.open(KnBrCommonPopUpComponent, { centered: true, size: 'md' });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.header = "Order Reference | Cust PO List"
    modalInstance.data = data
    modalInstance.materialNum = materialNum;
    modalInstance.image = true;
  };

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionSelectedProduct) {
      this.subscriptionSelectedProduct.unsubscribe();
    }
  }
}
